import type { JourneyItemType } from '../services/journeyTypes';

export const JOURNEY_ITEM_TYPES: JourneyItemType[] = [
    'chat',
    'check-in',
    'story',
    'lesson',
    'community-question',
    'tool',
];

export const JOURNEY_ITEM_TYPE_LABELS: Record<JourneyItemType, string> = {
    chat: 'Chat',
    'check-in': 'Check-in',
    story: 'Story',
    lesson: 'Lesson',
    'community-question': 'Community Question',
    tool: 'Tool',
};

export const JOURNEY_ITEM_TYPE_COLORS: Record<JourneyItemType, string> = {
    chat: 'bg-blue-100 text-blue-800',
    'check-in': 'bg-green-100 text-green-800',
    story: 'bg-purple-100 text-purple-800',
    lesson: 'bg-indigo-100 text-indigo-800',
    'community-question': 'bg-pink-100 text-pink-800',
    tool: 'bg-orange-100 text-orange-800',
};
